import axios from 'axios';
import $ from 'jquery';
import { Promise } from 'es6-promise';
import * as PortalAuthInstance from '@/common/module/PortalAuthInstance.ts';

export function httpGet(url: string, params?: Object, permission?: string, checkPermission?: string): any {
    return PortalAuthInstance.getToken()
        .then(token => {
            return axios({
                method: 'GET',
                url: url,
                headers: { Authorization: token, Permission: permission, CheckPermission: checkPermission ? checkPermission : 'true' },
                params: params,
            }).then((response) => checkPermissions(response))
                .catch((data) => {
                    processExceptions(data);
                });
        });
}
export function httpPost(url: string, data: Object, permission?: string): any {
    return PortalAuthInstance.getToken()
        .then(token => {
            return axios({
                method: 'POST',
                url: url,
                headers: { Authorization: token, Permission: permission },
                data: data
            }).then((response) => checkPermissions(response))
                .catch((data) => {
                    processExceptions(data);
                });
        });
}

export function httpFileGet(url: string, params?: Object): any {
    return PortalAuthInstance.getToken()
        .then(token => {
            return axios({
                method: 'GET',
                url: url,
                headers: { Authorization: token },
                params: params,
                responseType: 'blob'
            }).then((response) => {
                return new Promise((resolve) => {
                    resolve(response.data);
                });
            }).catch((data) => {
                processExceptions(data);
            });
        });
}

export function httpFilePost(url: string, data: Object, onProgressCheck: Function = null, cancelSource: any = axios.CancelToken.source()): any {
    return PortalAuthInstance.getToken()
        .then(token => {
            return axios({
                method: 'POST',
                url: url,
                onUploadProgress: (progressEvent) => {
                    if (onProgressCheck) {
                        let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        onProgressCheck(progress);
                    }
                },
                cancelToken: cancelSource.token,
                headers: { Authorization: token, 'Content-Type': 'multipart/form-data' },
                data: data
            }).then((response) => checkPermissions(response))
                .catch((thrown) => {
                    return new Promise((resolve, reject) => {
                        reject(new Error(thrown));
                    });
                });
        });
}

export function httpDelete(url: string, entityId: string): any {
    return PortalAuthInstance.getToken()
        .then(token => {
            return axios({
                method: 'DELETE',
                url: url,
                headers: { Authorization: token, 'Content-Type': 'application/json' },
                data: entityId
            }).then((response) => checkPermissions(response))
                .catch((data) => {
                    processExceptions(data);
                });
        });
}

function processExceptions(data) {
    console.log(data);
}

function checkPermissions(response) {
    return new Promise((resolve) => {
        if (!response.data.isSuccessful && response.data.errors) {
            response.data.errors.forEach((error) => {
                if (error.text === 'Forbidden') {
                    $('#noPermissionsPopup').modal('show');
                    return;
                } else {
                    resolve(response.data);
                }
            });
        } else {
            resolve(response.data);
        }
    });
}


// WEBPACK FOOTER //
// ./common/helpers/httpHelper.ts